import React from "react";
import { AiFillFacebook, AiFillInstagram, AiFillYoutube } from "react-icons/ai";
import { SiGmail } from "react-icons/si";

type propsType = {
  color: string;
  className?: string;
};
const SocialMedia = ({ color, className }: propsType) => {
  return (
    <div
      className={`mb-10 flex items-center justify-between ${color} text-lg space-x-4 animate-from-right ${className}`}
    >
      <AiFillInstagram className="transiiton duration-300 hover:text-primary-base  hover:transition-all hover:dura" />
      <AiFillFacebook className="transiiton duration-300 hover:text-primary-base  hover:transition-all hover:dura" />
      <AiFillYoutube className="transiiton duration-300 hover:text-primary-base  hover:transition-all hover:dura" />
      <SiGmail className="transiiton duration-300 hover:text-primary-base  hover:transition-all hover:dura" />
    </div>
  );
};

export default SocialMedia;
